module.exports = __webpack_public_path__ + "img/rules-back.1b21e936.svg";